import { useSelector } from 'react-redux';
import { HorizontalBarChart } from '../horizontalBarChart';
import { getColorClass } from './index'
import InfoMark from './infoMark';


const BehaviorsSection = () => {
  const { contextData: data = {}, activeTab, isUpdateBehaviors, activeBehaviorsection } = useSelector((state) => state.studentPerformenceConstruct);
  const { FETCH_CONSTRUCT_DATA: isConstructLoading = false, FETCH_CONSTRUCT_BEHAVIOR_DATA: isBehaviorLoader = false } = useSelector((state) => state?.loader)

  // const behaviorData = data?.behaviors?.[activeBehaviorsection] || {}
  const behaviorData = Object.values(data?.behaviors || {}).flat()?.filter((item, index, array) => array.findIndex(({label}) => label === item?.label) === index) 
  const colorClass = getColorClass(activeTab);
  
  return (
    <div className='grid grid-cols-1 gap-4'>
      <HorizontalBarChart
        isLoading={isConstructLoading || isBehaviorLoader}
        data={behaviorData}
        colorClass={colorClass}
        isUpdateBehaviors={isUpdateBehaviors}
        // handleReset={handleReset}
        infoIcon={<InfoMark
          message='This chart shows your performance percentiles compared to a
            nationally representative sample. The sliders allow you to adjust the
            values to see how different behaviors influence your construct
            probabilities.'
        />}
      />
    </div>
  )
}

export default BehaviorsSection